import { FormControl, InputLabel, MenuItem, Select } from "@material-ui/core";
import { useCallback, useEffect, useState } from "react";
import FilterComponent from "./FilterComponent";

export default function TextSelect({ title, options, onChange = () => {} }) {
  const [value, setValue] = useState("");

  useEffect(() => {
    if (!value && options?.length > 0) {
      setValue(options[0]);
    }
  }, [options, value]);

  const onSelect = useCallback(
    (evt) => {
      const selectedValue = evt.target.value;
      onChange({ title, selectedValue });
      setValue(selectedValue);
    },
    [title, onChange]
  );

  return (
    <FilterComponent>
      <FormControl fullWidth variant="outlined">
        <InputLabel id={title.replace(" ", "_").toLowerCase() + "_label"}>
          {title}
        </InputLabel>
        <Select
          id={title.replace(" ", "_").toLowerCase() + "_select"}
          labelId={title.replace(" ", "_").toLowerCase() + "_label"}
          onChange={onSelect}
          aria-labelledby="data-selector"
          value={value}
          label={title}
        >
          {options?.map((option) => (
            <MenuItem key={option} value={option}>
              {option}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </FilterComponent>
  );
}
